module.exports = __webpack_public_path__ + "img/project3.73e3c0c9.jpg";